var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hStackable fullHeight",style:(_vm.style()),on:{"mouseover":function($event){_vm.active = true},"mouseleave":function($event){_vm.active = false}}},[_vm._t("default",null,{"active":_vm.active})],2)}
var staticRenderFns = []

export { render, staticRenderFns }